import React from 'react';
import PropTypes from 'prop-types';
import NoSSR from 'react-no-ssr';
import styles from './index.css';
import Chip from 'Chip';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Market extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    /**
     * 插入 html
     */
    createMarkup = () => {
        return { __html: this.props.content };
    };

    /**
     * 渲染组件
     */
    render() {
        return (
            <div style={{ position: 'relative' }}>
                <div dangerouslySetInnerHTML={this.createMarkup()} />
            </div>
        );
    }
}

class Courier extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.courier}>
                <div style={{ margin: '15px 0 0' }} dangerouslySetInnerHTML={{ __html: content }} />
            </div>
        );
    }
}
/**
 * 定义 ContentRight 组件
 */
class ContentRight extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    render() {
        const { content } = this.props;
        const { market, courier } = content;

        return (
            <div className={styles.yib_right}>
                <div className={styles.box_04}>
                    <div className={styles.title_03c} style={{ marginBottom: '0px' }}>
                        <h4 style={{ width: '88px', marginRight: '5px' }}>
                            <a title="投教学堂">投教学堂</a>
                        </h4>
                    </div>
                </div>

                <div className={`${styles.dlkh} clearfix`}>
                    <NoSSR>
                        <Chip
                            id="10080"
                            type="static"
                            title="投教学堂静态碎片"
                            groupName="正文"
                            position="relative"
                            content={market}>
                            <Market />
                        </Chip>
                    </NoSSR>
                </div>
                <div className={styles.lcExpress}>
                    <div className={styles.title_03c} style={{ marginBottom: '0px' }}>
                        <h4 style={{ width: '88px', marginRight: '5px' }}>
                            <a title="理财速递" href="//finance.ifeng.com/zhuanti/">
                                理财速递
                            </a>
                        </h4>
                    </div>
                    <NoSSR>
                        <Chip
                            id="10082"
                            type="static"
                            title="理财速递静态碎片"
                            groupName="正文"
                            position="relative"
                            content={courier}>
                            <Courier />
                        </Chip>
                    </NoSSR>
                </div>
            </div>
        );
    }
}

export default errorBoundary(ContentRight);
